import React from 'react'
import { arrayOf, shape, string, number, bool, oneOfType } from 'prop-types'
import get from 'lodash/get'

import StatCard from './StatCard'

const StatList = ({ items }) => {
  return (
    <div className="row">
      {items.map(item => (
        <div
          key={item.id}
          className={`
            col-lg-${get(item, 'layout.lg', 3)}
            col-md-${get(item, 'layout.md', 4)}
            col-sm-${get(item, 'layout.sm', 6)}
            mb-3
          `}
        >
          <StatCard {...item} />
        </div>
      ))}
    </div>
  )
}

StatList.propTypes = {
  items: arrayOf(shape({
    id: oneOfType([number, string]).isRequired,
    title: string.isRequired,
    total: number.isRequired,
    last24Total: number,
    retryLink: string,
    showLoading: bool,
    layout: shape({
      sm: number,
      md: number,
      lg: number,
    })
  })),
}

StatList.defaultProps = {
  items: [],
}

export default StatList